// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GraphPage.css */
.container {
    max-width: 900px;
    margin: 40px auto;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
}

h1 {
    color: #343a40;
    font-size: 26px;
    margin-bottom: 20px;
}

.form-group {
    margin: 15px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.form-group label {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #495057;
}

input, select {
    width: 80%;
    max-width: 400px;
    padding: 8px;
    font-size: 14px;
    border: 1px solid #ced4da;
    border-radius: 5px;
    outline: none;
    transition: all 0.3s;
}

input:focus, select:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
}

button {
    margin-top: 15px;
    background: #007bff;
    color: white;
    font-size: 16px;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
}

button:hover {
    background: #0056b3;
}

.chart-container {
    margin-top: 30px;
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.chart-container canvas {
    max-width: 100%;
}
.download-btn {
    margin-top: 20px;
    background: #28a745;
    color: white;
    font-size: 16px;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
}

.download-btn:hover {
    background: #218838;
}
.quick-select {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-bottom: 15px;
}

.quick-select button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.3s;
}

.quick-select button:hover {
    background-color: #218838;
}

/* استایل فرم ورودی تاریخ */
input[type="datetime-local"] {
    width: 80%;
    max-width: 400px;
    padding: 8px;
    font-size: 14px;
    border: 1px solid #ced4da;
    border-radius: 5px;
    outline: none;
    transition: all 0.3s;
}

input[type="datetime-local"]:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
}

`, "",{"version":3,"sources":["webpack://./src/pages/GraphPage.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C","sourcesContent":["/* GraphPage.css */\n.container {\n    max-width: 900px;\n    margin: 40px auto;\n    padding: 20px;\n    background: #f8f9fa;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    text-align: center;\n}\n\nh1 {\n    color: #343a40;\n    font-size: 26px;\n    margin-bottom: 20px;\n}\n\n.form-group {\n    margin: 15px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.form-group label {\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 5px;\n    color: #495057;\n}\n\ninput, select {\n    width: 80%;\n    max-width: 400px;\n    padding: 8px;\n    font-size: 14px;\n    border: 1px solid #ced4da;\n    border-radius: 5px;\n    outline: none;\n    transition: all 0.3s;\n}\n\ninput:focus, select:focus {\n    border-color: #007bff;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);\n}\n\nbutton {\n    margin-top: 15px;\n    background: #007bff;\n    color: white;\n    font-size: 16px;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: 0.3s;\n}\n\nbutton:hover {\n    background: #0056b3;\n}\n\n.chart-container {\n    margin-top: 30px;\n    padding: 20px;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.chart-container canvas {\n    max-width: 100%;\n}\n.download-btn {\n    margin-top: 20px;\n    background: #28a745;\n    color: white;\n    font-size: 16px;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: 0.3s;\n}\n\n.download-btn:hover {\n    background: #218838;\n}\n.quick-select {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-bottom: 15px;\n}\n\n.quick-select button {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 10px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background 0.3s;\n}\n\n.quick-select button:hover {\n    background-color: #218838;\n}\n\n/* استایل فرم ورودی تاریخ */\ninput[type=\"datetime-local\"] {\n    width: 80%;\n    max-width: 400px;\n    padding: 8px;\n    font-size: 14px;\n    border: 1px solid #ced4da;\n    border-radius: 5px;\n    outline: none;\n    transition: all 0.3s;\n}\n\ninput[type=\"datetime-local\"]:focus {\n    border-color: #007bff;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
